import { apiClient } from "./apiClient";
import { API_CONFIG } from "@/config/api";

export type ShareStatus = "creating" | "ready" | "failed" | "expired" | "deleted";

export interface MediaShareResponse {
  shareId: string;
  token: string;
  status: ShareStatus;
  downloadUrl: string;
  fileCount: number;
  totalSizeBytes: number | null;
  expiresAt: string | null;
  jobId: string | null; // For polling job progress instead of share status
}

export interface ShareInfo {
  token: string;
  status: ShareStatus;
  fileCount: number;
  totalSizeBytes: number | null;
  expiresAt: string | null;
  downloadCount: number;
  createdAt: string | null;
  error?: string;
}

/**
 * Create a shareable download link for selected media items.
 * Creates a ZIP archive on the server and returns a download URL.
 */
export const createMediaShare = async (
  clientId: string,
  mediaItemIds: number[],
  retentionDays: number = 7
): Promise<MediaShareResponse> => {
  return apiClient.post<MediaShareResponse>(`/${clientId}/media/share`, {
    mediaItemIds: mediaItemIds,
    retentionDays: retentionDays,
  });
};

/**
 * Get info about a share by token (for the public download page).
 * No authentication required.
 */
export const getShareInfo = async (token: string): Promise<ShareInfo> => {
  return apiClient.get<ShareInfo>(`/share/${token}/info`);
};

/**
 * Get the download URL for a share.
 * This will redirect to the actual ZIP file.
 */
export const getShareDownloadUrl = (token: string): string => {
  return `${API_CONFIG.URL}/share/${token}/download`;
};
